// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3ur3L","colMin":"styles_colMin__4Kblf","colCheckbox":"styles_colCheckbox__3kuKG"};